<template>
  <div class="bindBatch">
    <div class="btn">
      <!-- addBatch -->
      <el-form ref="searchForm" :model="searchForm" :rules="searchFormRules" :inline="true" size="small">
        <el-form-item prop="type">
          <el-select v-model="searchForm.type" placeholder="选择" class="selectStyle" @change="changeType">
            <el-option label="批次" value="1" />
            <el-option label="SN号" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item prop="batchName">
          <el-input v-if="searchForm.type=='1'" v-model.trim="searchForm.batchName" maxlength="50" clearable placeholder="输入批次名称" />
        </el-form-item>
        <el-form-item prop="deviceSn">
          <el-input v-if="searchForm.type=='2'" v-model.trim="searchForm.deviceSn" maxlength="30" clearable placeholder="输入设备SN号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearchFilter">
            查询
          </el-button>
          <el-button size="small" type="primary" @click="batchDialogVisible=true">
            新建
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table v-loading="listLoading" :data="dataList" element-loading-text="Loading">
        <el-table-column type="index" label="序号" />
        <el-table-column prop="batchName" label="批次名称" />
        <el-table-column prop="deskNum" label="课桌数量" />
        <el-table-column prop="remark" label="备注" />
        <el-table-column prop="" label="创建时间" />
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="$router.push({path:'/mrDesk/mrDeskManage/bindingManag',query:{batchId:scope.row.id}})">
              课桌管理
            </el-button>
            <el-button type="text" size="mini" @click="updateBatch(scope.row)">
              修改
            </el-button>
            <el-button type="danger" size="mini" :disabled="scope.row.deskNum>0?true:false" @click="deleteBatch(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="page.total" :page.sync="page.pageNum" :limit.sync="page.pageSize" @pagination="pageCurriculumList" @handleSizeChange="handleSizeChange" />
    </div>
    <el-dialog v-if="batchDialogVisible" width="400px" :close-on-click-modal="false" :visible.sync="batchDialogVisible" :title="handleType =='add' ?'新建':'编辑'" @close="closeDailog">
      <el-form ref="editForm" :rules="editFormRules" size="small" label-width="110px" :model="editForm">
        <el-form-item prop="batchName" label="批次名称">
          <el-input v-model="editForm.batchName" type="text" maxlength="20" />
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model="editForm.remark" type="textarea" maxlength="100" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeDailog">
          取消
        </el-button>
        <el-button size="medium" type="primary" :loading="ajaxLoading" @click="handleAdd">
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getBindBatchPage, bindBatch, deleteBatchDetail, updateDeviceBatchInfo } from '@/api/productOperation/mrDesk/afterSale';
export default {
  data() {
    // SN号
    const validateDeviceSn = (rule, value, callback) => {
      if (!value) callback();
      const pattern = new RegExp(/^[\d\s-_*]+$|^[A-Za-z\s\d-_*]+$/);
      if (!pattern.test(value)) {
        callback(new Error('请输入数字或字母字符'));
      } else if (value.toString().length > 20) {
        callback(new Error('请输入20以内的字符'));
      } else {
        callback();
      }
    };
    return {
      dataList: [],
      page: { // 分页参数
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false,
      batchDialogVisible: false,
      editForm: { batchName: '', remark: '' },
      searchForm: {
        type: '1',
        batchName: '',
        deviceSn: ''
      },
      searchFormRules: {
        deviceSn: [{ validator: validateDeviceSn, trigger: 'blur' }]
      },
      editFormRules: {
        batchName: [{ required: true, message: '批次名称不能为空', trigger: 'blur' }]
      },
      handleType: 'add',
      ajaxLoading: false,
      option: {}
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    changeType() {
      if (this.searchForm.type === '1') {
        this.searchForm.deviceSn = '';
      } else {
        this.searchForm.batchName = '';
      }
    },
    handleSearchFilter() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.option = {
        batchName: this.searchForm.batchName,
        deviceSn: this.searchForm.deviceSn
      };
      this.getTableList();
    },
    updateBatch(row) {
      this.handleType = 'edit';
      this.editForm = { batchName: row.batchName, remark: row.remark, id: row.id };
      this.batchDialogVisible = true;
    },
    handleAdd() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.handleType === 'add') {
            bindBatch(this.editForm).then((res) => {
              if (res.code === '0') {
                this.batchDialogVisible = false;
                this.$message.success('操作成功');
                this.ajaxLoading = false;
                this.getTableList();
              }
            }).catch(() => {
              this.ajaxLoading = false;
            });
          } else {
            updateDeviceBatchInfo(this.editForm).then((res) => {
              if (res.code === '0') {
                this.batchDialogVisible = false;
                this.$message.success('操作成功');
                this.ajaxLoading = false;
                this.getTableList();
              }
            }).catch(() => {
              this.ajaxLoading = false;
            });
          }
        }
      });
    },
    closeDailog() {
      this.handleType = 'add';
      this.editForm = this.$options.data().editForm;
      this.batchDialogVisible = false;
    },
    addBatch() {
      this.batchDialogVisible = true;
    },
    // 分页
    pageCurriculumList(obj) {
      this.page.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.page.pageNum = 1;
      this.page.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      this.listLoading = true;
      getBindBatchPage({ pageNum: this.page.pageNum, pageSize: this.page.pageSize, ...this.option }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.dataList = [];
          this.page.total = 0;
        } else {
          this.dataList = res.data.list;
          this.page.total = res.data.total;
        }
      }).catch(err => {
        this.listLoading = false;
        console.log(err);
      });
    },
    deleteBatch(row) {
      this.$confirm(`确定要删除该批次么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return deleteBatchDetail(row.id);
      }).then(res => {
        this.$notify.success({ title: 'Success', message: '删除成功', showClose: false, duration: 2000 });
        this.getTableList();
      }).catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.bindBatch{
    .btn {
        margin: 10px 0;
        display: flex;
        justify-content: flex-end;
        margin-right: 10px;
        .selectStyle{
          width: 120px;
          margin-left: 20px;
        }
    }
}
</style>
